"use client";

import React from "react";
import { breakpointClasses, cls, cn, splitBreakpointProps } from "@/lib/utils";
import type { DropdownMenuShortcutProps } from "../types";

function DropdownMenuShortcut({
  className,
  ...props
}: DropdownMenuShortcutProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <span
      data-slot="dropdown-menu-shortcut"
      className={cn(
        cls`
          text-muted-foreground
          ml-auto
          text-xs
          tracking-widest
        `,
        className,
        classes,
      )}
      {...native}
    />
  );
}

DropdownMenuShortcut.displayName = "DropdownMenu.Shortcut";

export default DropdownMenuShortcut;
